import { atom } from "jotai";

//初始值
export const initList = [
    {
        typeId: "1",
        typeName: "单选题",
        typeCount: 0,
        counts: 0,
        score: 5,
        icon: require("./img/dan.png")
    },
    {
        typeId: "2",
        typeName: "多选题",
        typeCount: 0,
        counts: 0,
        score: 5,
        icon: require("./img/duo.png")
    },
    {
        typeId: "3",
        typeName: "判断题",
        typeCount: 0,
        counts: 0,
        score: 5,
        icon: require("./img/pan.png")
    },
    {
        typeId: "5",
        typeName: "填空题",
        typeCount: 0,
        counts: 0,
        score: 5,
        icon: require("./img/tian.png")
    }
];

export const initCountListAtom = atom(initList);
